import 'flickity-as-nav-for';
import Flicikity from 'flickity';
import { cursorNavigation, createPrevArrow, createNextArrow } from '../base/carousel';

export function create(element) {
	const carouselElement = element.querySelector('.js-gallery-items');
	const thumbnailsElement = element.querySelector('.js-gallery-thumbnails');

	if (!carouselElement) {
		return;
	}

	let carousel = new Flicikity(carouselElement, {
		cellAlign: 'center',
		contain: true,
		pageDots: false,
		prevNextButtons: false,
	});

	cursorNavigation(carousel);

	if (thumbnailsElement) {
		new Flicikity(thumbnailsElement, {
			asNavFor: carouselElement,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
		});

		const nextButton = thumbnailsElement.querySelector('.flickity-prev-next-button.next');
		const prevButton = thumbnailsElement.querySelector('.flickity-prev-next-button.previous');

		nextButton.innerHTML = createNextArrow();
		prevButton.innerHTML = createPrevArrow();
	}

	return {
		carousel,
	};
}
